import React, {useState} from 'react';

import UWM_COMMAND_TYPES from '@/consts/uwm/uwmCommandTypes';
import UWM_EVENT_TYPES from '@/consts/uwm/uwmEventTypes';
import useEventListener from '@/hooks/useEventListener';
import {useUWMUnavailabilityHandler} from '@/hooks/useUWMUnavailabilityHandler';
import log from '@/services/logger/log';
import routerService from '@/services/route/routerService';
import uwmExternalLinkService from '@/services/uwm/uwmExternalLinkService';
import uwmService from '@/services/uwm/uwmService';
import helpers from '@/utils/helpers';

import UWMUnavailabilityPopup from './UWMUnavailabilityPopup';

const UwmModule = (props) => {
    const {src, onModuleLoaded, onBack, onCompleteCleaningGuide, onSupportButtonClick} = props;
    const [moduleHeight, setModuleHeight] = useState();

    const onBackButtonClick = () => {
        if (onBack) {
            onBack();
        } else {
            routerService.goBack();
        }
    };

    const {isPopupVisible, handleRefresh, setIsDataLoaded, setHasDataError} = useUWMUnavailabilityHandler();

    useEventListener(
        'message',
        (event) => {
            const {detail} = event?.data || {};

            if (detail?.command === UWM_COMMAND_TYPES.UWM_EVENT) {
                log.debug(`UwmModule: detail: ${JSON.stringify(detail)}`);

                switch (detail.payload?.type) {
                    case UWM_EVENT_TYPES.UWM_MODULE_LOADED: {
                        onModuleLoaded();
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_DATA_RECEIVED_SUCCESS: {
                        setIsDataLoaded(true);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_RESIZE: {
                        setModuleHeight(detail.payload.height);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_BACK_BUTTON_CLICK: {
                        helpers.runFunction(onBackButtonClick);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_INITIALIZATION_ERROR: {
                        log.info(`UwmModule: UWM_MODULE_INITIALIZATION_ERROR: ${JSON.stringify(detail)}`);
                        setHasDataError(true);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_COMPLETE_GUIDE: {
                        helpers.runFunction(onBackButtonClick);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_COMPLETE_CLEANING_GUIDE: {
                        helpers.runFunction(onCompleteCleaningGuide);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_SUPPORT_BTN_CLICK: {
                        helpers.runFunction(onSupportButtonClick);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_TRACK_ANALYTICS: {
                        uwmService.trackGaEvent(detail.payload.eventType, detail.payload.params);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_GET_EXTERNAL_LINKS: {
                        uwmExternalLinkService.getExternalLinks(detail.payload.externalLinks, detail.payload.isRefetch);
                        break;
                    }
                    default:
                        break;
                }
            }
        },
        window
    );

    return isPopupVisible ? (
        <UWMUnavailabilityPopup handleRefresh={handleRefresh} />
    ) : (
        <iframe title='uwmIframe' id='uwmIframe' src={src} className='min-h-screen w-full' height={moduleHeight} />
    );
};

export default UwmModule;
